const AboutRayInsurance = () => {
  return (
    <section id="about-Ray-insurance" className="flex justify-center w-full">
      <div className="w-4/5 max-w-screen-xl pt-28 pb-16 space-y-10">
        <h4 className="text-5xl sm:text-7xl font-bold text-custom-red">
          Ray Sigorta Hakkında
        </h4>
        <div className="flex flex-row items-center">
          <h5 className="text-custom-red text-xl sm:text-3xl font-extrabold whitespace-nowrap mr-5">
            Biz kimiz
          </h5>
          <div className="border-b border-custom-red w-full"></div>
        </div>
        <div>
          <p>
            1958 yılından günümüze, bireysel ve kurumsal olarak hayat dışı tüm
            branşlarda faaliyet gösteriyoruz. 1997 yılında halka açılan Ray
            Sigorta, 2009 yılından itibaren Avrupa’nın en güçlü uluslararası
            sigorta şirketler grubu Vienna Insurance Group’un çatısı altında yer
            alıyor. <br />
            <br />
            Amacımız, bilgi birikimimiz ve uluslararası gücümüzle,
            müşterilerimize hayatlarına eşlik ederek ihtiyaç duyabilecekleri her
            türlü finansal güvenceyi sağlamak. <br />
            <br />
            Müşterilerimizi, onlar için değerli olanları, hayallerini ve
            geleceklerini odak noktamıza koyarak günümüzün değişen dinamiklerine
            uygun, sürekli geliştirdiğimiz ve yenilikçi çözümlerimizle değer
            yaratmak için buradayız. Şirket çalışanlarımız ve tüm iş
            ortaklarımızın yüksek iş ahlâkı, değer yaratma ve müşteri
            memnuniyeti odaklı çalışmalarıyla Türkiye’nin en değerli 100 markası
            arasında yer alıyoruz. <br />
            <br />
            Sektördeki deneyimimizin bize sağladığı bilgi birikimiyle
            alışılagelmiş iş yapış yöntemlerini dijital teknolojilere dönüştüren
            teknik alt yapımız, yetenekli ve kaliteli insan kaynağımız ve güçlü
            finansal yapımızla tercih edilen marka olmaya devam ediyoruz.
          </p>
        </div>
        <div className="pt-20">
          <a
            className="bg-custom-red text-white font-bold text-sm md:text-2xl py-3 px-4 pl-6"
            href="https://www.raysigorta.com.tr/"
          >
            Daha ayrıntılı bilgi almak için tıklayın…
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutRayInsurance;
